/**
 *
 */
import React from 'react';
import {getUserInfo} from '../../axios';


class Dashboard extends React.Component {
    render() {
        const auth = getUserInfo();
        console.log(auth);
        // history.push('/');
        return (
            <div className="gutter-example button-demo">
                Dashboard
            </div>
        )
    }
}

export default Dashboard;